interface OverviewProps {
   overview: {
     description: string;
     learnings: string[];
     extraNote?: string;
   }
 }
 
 const Overview = ({ overview }: OverviewProps) => {
    return (
       <div className="courses__overview-wrap">
          <h3 className="title">Course Description</h3>
          <p>{overview.description}</p>
 
          <h3 className="title">What you&apos;ll learn in this course?</h3>
          <ul className="about__info-list list-wrap">
             {overview.learnings.map((point, index) => (
               <li className="about__info-list-item" key={index}>
                 <i className="flaticon-angle-right"></i>
                 <p className="content">{point}</p>
               </li>
             ))}
          </ul>
 
          {overview.extraNote && <p className="last-info">{overview.extraNote}</p>}
       </div>
    )
 };
 
 export default Overview;
 